<template>
  <!-- 新增：页面底部的Footer组件，用于展示公司名称和备案号 -->
  <div class="site-footer">
    <div class="footer-content">
      <p class="company-name">广州市富尔菱自动化系统有限公司</p>
      <div class="icp-info">
        <!-- 新增：版权文字 -->
        <span class="copyright">
          © 2026 All Rights Reserved
        </span>
        <span class="divider">|</span>
        <!-- 新增：备案号超链接及左侧备案图标 -->
        <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">
          <img src="https://www.gdzwfw.gov.cn/portal/static/images/components/footer/beian.png" alt="备案图标" class="beian-icon" />
          粤ICP备17083762号
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// 新增：Footer组件的逻辑部分
export default {
  name: "SiteFooter",
};
</script>

<style scoped>
/* 新增：Footer组件的样式，采用与Home页面类似的蓝色调和居中风格 */
.site-footer {
  width: 100%;
  padding: 10px 0;
  background-color: rgba(0, 0, 0, 0.4); /* 半透明背景，不完全遮挡Swiper背景 */
  text-align: center;
  position: absolute; /* 定位在底部 */
  bottom: 0;
  left: 0;
  z-index: 100;
}

.company-name {
  margin: 0 0 5px 0;
  font-size: 16px;
  color: #fff;
  font-family: "阿里楷体", sans-serif; /* 与首页字体风格一致 */
  letter-spacing: 1px;
}

.icp-info {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #ddd;
}

.copyright {
  display: flex;
  align-items: center;
}

.beian-icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  vertical-align: middle;
}

.divider {
  margin: 0 10px;
  color: #ccc;
}

.icp-link {
  color: #ddd;
  text-decoration: none;
  transition: color 0.3s;
  display: flex; /* 优化：使图标和文字垂直居中对齐 */
  align-items: center;
}

.icp-link:hover {
  color: #008fd7; /* 悬停颜色采用Home主题色 */
}
</style>
